module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/ic_large_thumbsup-7d1b887d6c8953c49d6f779fd85b7c06.png";